import { useEffect, useState } from 'react';
import { apiMaybe } from '../../services/apiClient';
import { CONTRACT_CATEGORY_OPTIONS, CONTRACT_TYPE_FALLBACK_OPTIONS } from '../../constants/contracts';

// Contract type/category option lists for schema targeting. Server enums when
// reachable, constants fallback otherwise (same degrade posture as the forms).
export default function useEnumOptions() {
  const [typeOptions, setTypeOptions] = useState(
    CONTRACT_TYPE_FALLBACK_OPTIONS.map((o) => o.value)
  );
  const [categoryOptions, setCategoryOptions] = useState(
    CONTRACT_CATEGORY_OPTIONS.map((o) => o.value)
  );

  useEffect(() => {
    let cancelled = false;
    apiMaybe('/enums').then((res) => {
      if (cancelled || !res) return;
      if (Array.isArray(res.contractTypes) && res.contractTypes.length) {
        setTypeOptions(res.contractTypes);
      }
      if (Array.isArray(res.contractCategories) && res.contractCategories.length) {
        setCategoryOptions(res.contractCategories);
      }
    });
    return () => { cancelled = true; };
  }, []);

  return { typeOptions, categoryOptions };
}
